import { ShieldCheck } from '@phosphor-icons/react';

import { AccountForm } from '@/components/account/account-form';
import { ButtonLink, EmptyState } from '@/components/ui';
import { useSuspenseQuery } from '@tanstack/react-query';
import { accountQuery } from '@/queries';

export default function AccountPage() {
  const { me, orders, quotes } = useSuspenseQuery(accountQuery).data;
  const user = me.user;

  if (!user) {
    return (
      <div className="mx-auto max-w-[1180px] px-[30px] py-12">
        <h1 className="mb-8 text-[32px] font-extrabold tracking-[-0.03em]">Your account</h1>
        <EmptyState
          title="Sign in to your account"
          body="Your profile, addresses, orders and quotes live here."
          action={<ButtonLink href="/auth/sign-in?next=/account">Sign in</ButtonLink>}
        />
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-[1180px] px-[30px] py-12">
      <h1 className="text-[32px] font-extrabold tracking-[-0.03em] sm:text-[38px]">
        Your account
      </h1>
      <p className="mt-2 text-[15px] text-muted">{user.email}</p>

      {me.isAdmin && (
        <div className="mt-6 flex flex-wrap items-center justify-between gap-4 rounded-[10px] border border-brand/25 bg-brand-wash p-5">
          <p className="flex items-center gap-2.5 text-[15px] font-semibold">
            <ShieldCheck size={20} weight="bold" className="text-brand-ink" aria-hidden />
            You have {user.role} access to the admin.
          </p>
          <ButtonLink href="/admin" size="sm">
            Open the admin
          </ButtonLink>
        </div>
      )}

      <div className="mt-10 grid gap-10 lg:grid-cols-[minmax(0,1fr)_320px] lg:items-start">
        <AccountForm email={user.email} name={user.name} />

        <aside className="space-y-4">
          <div className="rounded-[10px] border border-line bg-panel p-5">
            <h2 className="text-sm font-bold">Activity</h2>
            <dl className="mt-4 space-y-2.5 text-[15px]">
              <div className="flex justify-between gap-4">
                <dt className="text-muted">Orders</dt>
                <dd className="font-semibold">{orders.length}</dd>
              </div>
              <div className="flex justify-between gap-4">
                <dt className="text-muted">Quotes</dt>
                <dd className="font-semibold">{quotes.length}</dd>
              </div>
            </dl>
            <div className="mt-5">
              <ButtonLink href="/orders" weight="secondary" size="sm">
                View orders
              </ButtonLink>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
}
